module.exports = __webpack_public_path__ + "static/media/begin_exam.eca57a7c.gif";